import { StorySlug } from "@/api/episodes-types";
import { PromptType } from "@/api/prompts-types";
import { CopyButton } from "@/components/ui/CopyButton";
import { pretty, prettyStoryType } from "@/utils/pretty";
import { Breadcrumbs, Typography } from "@mui/material";

type Props = {
  id: string;
  name: string;
  storyType: StorySlug;
  type: PromptType;
};

export function PromptBreadcrumbs({ id, name, storyType, type }: Props) {
  return (
    <Breadcrumbs separator="·">
      <CopyButton text={id}>
        <Typography>{`Prompt ID: ${id}`}</Typography>
      </CopyButton>
      <CopyButton text={name}>
        <Typography>{`Name: ${name}`}</Typography>
      </CopyButton>
      <Typography>{`Story type: ${prettyStoryType(storyType)}`}</Typography>
      <Typography>{`Prompt type: ${pretty(type)}`}</Typography>
    </Breadcrumbs>
  );
}
